import { Typography } from '@ori-ui/mui';
import type { GlobalCustomersDocumentTypeDto } from '@ori/global-api-client-react';
import type { StaticCustomersMetadataIdentityCardDocumentPropertyDto } from '@ori/static-api-client-react';
import type { ReactElement, FC } from 'react';

import { useCustomerDocumentsInfos, useDocumentTypes } from '../../models/api';
import { Loading } from '../Loading';
import { DocumentContent } from './DocumentContent';
import { DocumentHeader } from './DocumentHeader';
import { RootContainer } from './DocumentStyledComponents';

interface IDocumentProps {
  documentTypeId: number;
  documentLabel: ReactElement;
  documentInfoText: ReactElement;
  documentIds: number[];
  handleDocumentsChange?: (documentIds: number[]) => void;
  isDeleteConfirmationRequired?: boolean;
  editableDocument?: boolean;
  config?: StaticCustomersMetadataIdentityCardDocumentPropertyDto;
  name: string;
  isRequired?: boolean;
}

export const Document: FC<IDocumentProps> = (props) => {
  const {
    documentIds,
    documentTypeId,
    isDeleteConfirmationRequired,
    editableDocument,
    name,
    config,
    isRequired,
    documentLabel,
    documentInfoText,
    handleDocumentsChange,
  } = props;

  const { data: documentsTypeData } = useDocumentTypes();
  const { data: documentsInfoData } = useCustomerDocumentsInfos();

  const getTypeById = (documentTypeIdProperty: number): GlobalCustomersDocumentTypeDto | undefined =>
    documentsTypeData?.find((type) => type.documentTypeId === documentTypeIdProperty);

  const isLoading = !documentsTypeData || !documentsInfoData;

  const documentType = getTypeById(documentTypeId);

  return (
    <RootContainer>
      <DocumentHeader
        label={documentLabel}
        requiredDocument={Boolean(isRequired)}
      />
      <Typography
        paragraph
        variant="body1"
        align="left"
      >
        {documentInfoText}
      </Typography>
      <DocumentContent
        documentInpuName={name}
        documentIsRequired={Boolean(isRequired)}
        documentTypeId={documentTypeId}
        documentType={documentType}
        documentIds={documentIds}
        handleDocumentsChange={handleDocumentsChange}
        editableDocument={editableDocument}
        deleteConfirmationRequired={isDeleteConfirmationRequired}
        configDocument={config}
      />
      {isLoading ? <Loading /> : null}
    </RootContainer>
  );
};
